export const handleErrors = (errors, elementWithMistakes) => {
  if (elementWithMistakes && errors && errors.length > 0){
    errors.forEach((error) => {
      const errorMessageElement = elementWithMistakes.nextElementSibling;
      
      if (
        errorMessageElement &&
        errorMessageElement.classList.contains('error-message-back')
      ) {
        errorMessageElement.textContent = error;
        
        if (errorMessageElement.classList.contains('inActive')){
          errorMessageElement.classList.remove('inActive');
        }
        
        errorMessageElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    });
  }
}

export const clearErrors = () => {
  const errorMessages = document.querySelectorAll('.error-message-back');
  errorMessages.forEach((errorMessage) => {
    errorMessage.textContent = '';
    errorMessage.classList.add('inActive');
  });
}
